import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const STag = ({ variant = "secondary", className = "", children })=>{
    const colorNames = {
        inactive: "bg-white text-white/50",
        primary: "bg-brand-primary text-brand-primary",
        secondary: "bg-white text-white",
        success: "bg-green-300 text-green-400",
        warning: "bg-yellow-300 text-yellow-400",
        danger: "bg-red-300 text-red-400"
    };
    return /*#__PURE__*/ _jsx("span", {
        className: `inline-flex items-center gap-2 text-sm bg-opacity-10 ${colorNames[variant]} px-2 p-1 rounded-md ${className}`,
        children: children
    });
};
export { STag };
